import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../service/error.service';
import { Messages } from '../messages/messages';
import { DialogService } from '../service/dialog.service';

export const INTERCEPTOR_SKIP_HEADER = 'x-skip-interceptor';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private routingService: AuthService,
        private dialogService: DialogService,
        private errorService: ErrorService) { }

    private isPublicRoute(url: string): boolean {
        return url.match('login') !== null
            || url.match('user-email/') !== null
            || url.match('check-otp') !== null
            || url.match('send-otp-token') !== null;
    }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401) {
            this.dialogService.openOnlyOneDialog(Messages.EXPIRED_SESSION);
            this.routingService.logout();
            return of(err.message);
        }

        return throwError(() => err);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const currentUserData = this.routingService.getStorageData();
        const isTokenExpirated = this.routingService.isTokenExpirated();
        const isLoggedIn = this.routingService.isLoggedIn();

        if (request.url.match(':8088') !== null) {
            return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
        }

        if (!isLoggedIn && this.isPublicRoute(request.url)) {
            request = request.clone({
                setHeaders: {
                    'Api-Key': `${environment.apiKey}`,
                }
            });
            return next.handle(request);
        }

        if (request.headers.has(INTERCEPTOR_SKIP_HEADER)) {
            return next.handle(request);
        }

        if (currentUserData && isLoggedIn) {
            request = request.clone({
                setHeaders: {
                    'x-backoffice-token': `${currentUserData.sessionToken}`,
                    'Api-Key': `${environment.apiKey}`,
                }
            });
            return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
        }

        if (isTokenExpirated) {
            this.errorService.handleXHRError(new HttpErrorResponse({}), Messages.EXPIRED_SESSION);
        }

        this.routingService.logout();
        return throwError(() => new HttpErrorResponse({
            status: 401,
            statusText: 'UNAUTHORIZED',
            error: { message: 'Session expired or invalid authentication context' }
        }));

    }
}
